import { doGet } from 'api/request';
import { LOGGER_TYPE } from 'api/types';
import type { SkipTableJoinResponse } from './types';

export const getSkipTableJoinSettings = (accountId: string) => {
  return doGet<SkipTableJoinResponse>(
    `accounts/${accountId}/nebula-settings/skip-table-join`,
    LOGGER_TYPE.ANALYTICS,
    { prefix: 'nebula' },
  );
};
